/**
 * Outbound-Webhooks Fixture.
 * Spec: lmm-wiki/wiki/orbit-specs/outbound-webhooks-admin.md
 */

const KNOWN_EVENT_TYPES = [
  'user.anonymized',
  'user.suspended',
  'user.lifted_suspension',
  'user.email_changed',
  'user.vat_id_status_changed',
  'subscription.created',
  'subscription.cancelled',
  'subscription.cancel_intent_created',
  'subscription.cancel_intent_confirmed',
  'order.paid',
  'order.refunded',
  'invoice.credited',
  'service.failed',
  'service.activated',
];

function persist() {
  if (typeof window === 'undefined') return null;
  if (!window.__ORBIT_WEBHOOKS_DB__) {
    window.__ORBIT_WEBHOOKS_DB__ = {
      webhooks: [
        {
          id: 1,
          label: 'valiKey backend',
          url: 'https://valikey.app/webhooks/core',
          eventFilters: ['user.*', 'subscription.cancel_intent_confirmed'],
          isActive: true,
          lastSuccessAt: new Date(Date.now() - 4 * 60_000).toISOString(),
          lastFailureAt: null,
          lastError: null,
          createdAt: new Date(Date.now() - 90 * 86_400_000).toISOString(),
        },
        {
          id: 2,
          label: 'Slack #ops Alert-Bridge',
          url: 'https://ops.valitype.net/webhook-bridge/slack',
          eventFilters: ['service.failed', 'subscription.cancelled'],
          isActive: true,
          lastSuccessAt: new Date(Date.now() - 2 * 3_600_000).toISOString(),
          lastFailureAt: null,
          lastError: null,
          createdAt: new Date(Date.now() - 30 * 86_400_000).toISOString(),
        },
        {
          id: 3,
          label: 'Legacy CRM (deprecated)',
          url: 'https://crm.internal.example.com/hooks/valitype',
          eventFilters: ['user.*'],
          isActive: false,
          lastSuccessAt: new Date(Date.now() - 45 * 86_400_000).toISOString(),
          lastFailureAt: new Date(Date.now() - 30 * 86_400_000).toISOString(),
          lastError: 'HTTP 502 — Bad Gateway',
          createdAt: new Date(Date.now() - 365 * 86_400_000).toISOString(),
        },
      ],
      deliveries: buildDeliveries(),
    };
  }
  return window.__ORBIT_WEBHOOKS_DB__;
}

function buildDeliveries() {
  const now = Date.now();
  const STATUSES = ['succeeded', 'succeeded', 'succeeded', 'failed', 'in_flight', 'pending', 'dead'];
  const HTTP = { succeeded: 200, failed: 502, in_flight: null, pending: null, dead: 503 };
  const list = [];
  for (let i = 0; i < 40; i += 1) {
    const status = STATUSES[i % STATUSES.length];
    const webhookId = (i % 3) + 1;
    const eventType = KNOWN_EVENT_TYPES[i % KNOWN_EVENT_TYPES.length];
    const attempts = status === 'failed' ? 3 : status === 'dead' ? 8 : 1;
    const createdAt = new Date(now - i * 12 * 60_000).toISOString();
    list.push({
      id: 12_000 + i,
      webhookId,
      eventType,
      eventId: `evt_${randomHex(8)}`,
      status,
      attempts,
      httpStatus: HTTP[status],
      lastError:
        status === 'failed'
          ? 'HTTP 502 — Bad Gateway'
          : status === 'dead'
          ? 'HTTP 503 nach 8 Versuchen — Receiver offline?'
          : null,
      nextAttemptAt:
        status === 'pending' || status === 'in_flight'
          ? new Date(now + 60_000).toISOString()
          : null,
      deliveredAt: status === 'succeeded' ? new Date(now - i * 12 * 60_000 + 800).toISOString() : null,
      createdAt,
    });
  }
  return list;
}

export function webhooksFixture() {
  const db = persist();
  return {
    webhooks: [...db.webhooks],
    knownEventTypes: KNOWN_EVENT_TYPES,
  };
}

export function deliveriesFixture({ webhookId, status } = {}) {
  const db = persist();
  let items = [...db.deliveries];
  if (webhookId) items = items.filter((d) => d.webhookId === Number(webhookId));
  if (status) items = items.filter((d) => d.status === status);
  return { deliveries: items.slice(0, 100) };
}

export function createWebhookFixture(payload) {
  const db = persist();
  const id = (db.webhooks.at(-1)?.id ?? 0) + 1;
  const secret = randomHex(64);
  const created = {
    id,
    label: payload.label,
    url: payload.url,
    eventFilters: payload.eventFilters,
    isActive: true,
    lastSuccessAt: null,
    lastFailureAt: null,
    lastError: null,
    createdAt: new Date().toISOString(),
  };
  db.webhooks.push(created);
  return {
    ...created,
    secret,
    warning:
      'Dieser Secret wird genau einmal angezeigt. Verloren = Rotate erforderlich.',
  };
}

export function updateWebhookFixture(id, patch) {
  const db = persist();
  const target = db.webhooks.find((w) => w.id === Number(id));
  if (!target) throw new Error(`Webhook ${id} nicht gefunden`);
  Object.assign(target, patch);
  return { ...target };
}

export function deleteWebhookFixture(id) {
  const db = persist();
  const idx = db.webhooks.findIndex((w) => w.id === Number(id));
  if (idx === -1) throw new Error(`Webhook ${id} nicht gefunden`);
  db.webhooks.splice(idx, 1);
  return { ok: true };
}

export function rotateWebhookFixture(id) {
  return { id: Number(id), secret: randomHex(64) };
}

export function redeliverFixture(id) {
  const db = persist();
  const delivery = db.deliveries.find((d) => d.id === Number(id));
  if (delivery) {
    delivery.status = 'pending';
    delivery.attempts += 1;
    delivery.nextAttemptAt = new Date(Date.now() + 30_000).toISOString();
  }
  return { ok: true, deliveryId: Number(id) };
}

function randomHex(len) {
  const c = '0123456789abcdef';
  let s = '';
  for (let i = 0; i < len; i += 1) s += c[Math.floor(Math.random() * 16)];
  return s;
}
